import { nhAddressCreator, sectionConfiguration } from '@app/helpers/models.helpers';
import Vs from '@app/services/validators/validators.service';
import { MedicalAppealRequestInfoComponent } from './medical-appeal-request-info.component';


const formValidation = (builder:any, recordData:any) => {
  const medAplCaseIndvData = recordData.medAplCaseIndvData || [];
  const loggedInIndv = recordData.loggedInIndv || null;
  const tccData = recordData.tccMedAplRqstInfoData || {};
  const appealCaseNumber = tccData.caseNum || null;
  const medAppealAddr = tccData.medAppealAddress || {};

  const helpers = builder.group({
    selectedMemberValidation: [null, Vs.required]
  });

  const data = builder.group({
    appealCaseNumber: [appealCaseNumber],
    medAplCaseIndvData: [medAplCaseIndvData],
    loggedInIndv: [loggedInIndv],
    tccMedAplRqstInfoData: builder.group({
      appNum: [tccData.appNum],
      caseNum: [tccData.caseNum],
      indvId: [tccData.indvId],
      filingMaForCd: [tccData.filingMaForCd],
      callerRelationshipCd: [tccData.callerRelationshipCd],
      callerFstName: [tccData.callerFstName, [Vs.maxLength(45), Vs.medAplCallerFstName]],
      callerLastName: [tccData.callerLastName, [Vs.maxLength(45), Vs.minLength(2), Vs.medAplCallerLastName]],
      callerPhnNum: [tccData.callerPhnNum, Vs.phoneNumberHOH],
      callerPhnNumExt: [tccData.callerPhnNumExt],
      callerPrimLangCd: [tccData.callerPrimLangCd],
      callerPrimLangOther: [tccData.callerPrimLangOther, [Vs.maxLength(30), Vs.otherLanguage]],
      isMemberPresentSw: [tccData.isMemberPresentSw],
      medAppealAddress: builder.group({
        addressFormat: [medAppealAddr.addressFormat],
        address: builder.group(nhAddressCreator(medAppealAddr.address)),
        addressType: [medAppealAddr.addressType]
      }),
      resSameAsMailAddrSw: [tccData.resSameAsMailAddrSw]
    })
  });

  return { helpers, data };
};

export default sectionConfiguration(
  MedicalAppealRequestInfoComponent,
  formValidation,
  ['MEDAPLFILINGFOR', 'CALLERRELATIONSHIP', 'SPOKEHEARLANGUAGE', 'YESNO', 'ADDRESSFORMATTYPES', 'STATE', 'COUNTY', 'NAMESUFFIX', 'MILITARYPOCODES', 'STATEMILITARY'],
  [],
  {},
  {
    hasSummary: false,
    showSubmit: false,
    showComments: false,
    showSaveAndExit: false,
    labelExit: null
  }
);